import React from "react";
import { Link } from "react-router-dom";
import RouteNames from "../routes/type";

const NotFoundPage: React.FC = () => {
  return (
    <div className="bg-gray-100 h-screen flex flex-col items-center justify-center p-4">
      <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-lg max-w-md w-full text-center">
        <h1 className="text-9xl font-black text-primary tracking-tighter">
          404
        </h1>

        <h2 className="mt-4 text-3xl md:text-4xl font-bold text-gray-800">
          Page Not Found
        </h2>

        <p className="mt-4 text-gray-600">
          Oops! The page you are looking for does not exist. It might have been
          moved or deleted.
        </p>

        <div className="mt-8">
          <Link
            to={RouteNames.AUTH}
            className="inline-block px-8 py-3 font-semibold text-gray-900 bg-primary rounded-lg shadow-md hover:bg-primaryHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primaryHover transition-all duration-300 ease-in-out"
          >
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
